import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';

type FetchWithWidgetTokenArgs = {
  url: string | URL;
  fetchArgs?: RequestInit;
  widgetToken?: string;
};

export async function fetchWithWidgetToken({
  url,
  fetchArgs,
  widgetToken
}: FetchWithWidgetTokenArgs) {
  return fetch(url, {
    ...fetchArgs,
    headers: buildHeadersWithWidgetToken(widgetToken, fetchArgs?.headers)
  });
}
